export default "__VITE_ASSET__aw1uGsIK__"